// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteOrderModal_modal__9Dts6","modalBody":"DeleteOrderModal_modalBody__vzZ1a","modalFooter":"DeleteOrderModal_modalFooter__4OsGO"};